module.exports = __webpack_public_path__ + "img/m06.ca5faace.png";